import * as React from "react";
import { Dialog, DialogContent, Slide } from "@mui/material/";
import ReactPlayer from "react-player";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogVideo({ open, setOpen }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="xl"
    >
      <DialogContent style={{ padding: "10px" }}>
        <Player />
      </DialogContent>
    </Dialog>
  );
}

const Player = () => (
  <div className="player-wrapper">
    <ReactPlayer
      url="https://www.youtube.com/watch?v=tCAP85drI6g"
      className="react-player"
      playing={true}
      width="100%"
      height="100%"
      controls={false}
    />
  </div>
);

export default DialogVideo;
